/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from 'react'
import Dashboardheadernft from '../directives/dashboardheadernft';
import Dashboardsidebarnft from '../directives/dashboardsidebarnft';

import { getRigNftDetailsForUsersAction, insertRigAction, getUserMarketplaceBalanceAction } from '../Action/user.action';
import config from '../coreFIles/config';
import { Row, Col, Tab, Nav, Modal } from 'react-bootstrap';
import Swal from 'sweetalert2';
import { Toaster, toast } from 'react-hot-toast';
import '.././component/rig.css';

const Rig = () => {
    const [toggleSet, settoggleSet] = useState(1);
    const [rigBox, setRigBox] = useState([]);
    const [ShowXRig, setShowXRig] = useState(1)
    const [ShowYRig, setShowYRig] = useState(false)
    const [show, setShow] = useState(false)
    const [fee, setFee] = useState("")
    const [userMarketplaceBalance, setUserMarketplaceBalance] = useState("")
    useEffect(() => {
        getRigHistoryForUsersAPI(1);
    }, []);

    const userBalance = async () => {
        let res3 = await getUserMarketplaceBalanceAction();
        if (res3.success) {
            setUserMarketplaceBalance(res3.data.main_balance);
            return res3.data.main_balance
        } else {
        }
    }

    const getRigHistoryForUsersAPI = async (data) => {
        if (data == 1) {
            let res = await getRigNftDetailsForUsersAction({ nft_category_id: data });
            if (res.success) {
                setRigBox(res.data.RigNftDetails)
                // setFee(res.data.rigFees)

                let element = res.data.RigNftDetails.filter(item => item.categoryId === 1 && item.nftCount >= item.rig_quantity)
                if (element.length == 9) {
                    setShowYRig(true)
                    setFee(res.data.rigFees)
                }
                else {
                    setShowYRig(false)
                }
            } else {
            }
            setShowXRig(1)
        }
        if (data == 2) {
            let res = await getRigNftDetailsForUsersAction({ nft_category_id: data });
            if (res.success) {
                setRigBox(res.data.RigNftDetails)

                let element = res.data.RigNftDetails.filter(item => item.categoryId === 2 && item.nftCount >= item.rig_quantity)
                if (element.length == 9) {
                    setShowYRig(true)
                    setFee(res.data.rigFees)

                }
                else {
                    setShowYRig(false)
                }
            } else {
            }
            setShowXRig(2)
        }
        if (data == 3) {
            let res = await getRigNftDetailsForUsersAction({ nft_category_id: data });
            if (res.success) {
                setRigBox(res.data.RigNftDetails)

                let element = res.data.RigNftDetails.filter(item => item.categoryId === 3 && item.nftCount >= item.rig_quantity)
                if (element.length == 9) {
                    setShowYRig(true)
                    setFee(res.data.rigFees)

                }
                else {
                    setShowYRig(false)
                }
            } else {
            }
            setShowXRig(3)
        }
    }

    const newFunc = () => {
        window.location.href = `${config.nfthomeurl}nftmarketplace`
    }

    const toggleManage = (data) => {
        settoggleSet(data)
    }

    const createRig = async (data) => {
      
        let balance = await userBalance()
        Swal.fire({
            // title: "Rig Creation Charge",
            html: `<h4>Rig Creation Charge</h4><p style="font-size:17px">A charge of MNT will be applicable for Rig creation.</p>
            <div className="container mt-3">
            <div className="row justify-content-center">
            <div className="col-md-8 ">
            <table width="100%" className="text-left">
                <tr>
                    <td style="width:45%">Current Balance</td>
                    <td style="">:</td>
                    <td style="width:45%"> ${balance} MNT</td>
                </tr>
                <tr>
                    <td style="width:45%">Debit</td>
                    <td style="">:</td>
                    <td style="width:45%">${fee} MNT</td>
                </tr>
            </table>
            </div>
            </div>
            </div>
            `,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#435EEF",
            cancelButtonColor: "#d33",
            confirmButtonText: "Next",
            reverseButtons: true
        }).then(async (result) => {
            if (result.isConfirmed) {
                if (balance < fee) {
                    Swal.fire({
                        html: " <h4 className='mb-3'> Add funds </h4> <div>Insufficient balance.</div>",
                        text: "Insufficient balance.",
                        icon: "warning",
                        showCancelButton: true,
                        confirmButtonColor: "#435EEF",
                        cancelButtonColor: "#d33",
                        confirmButtonText: "Deposit",
                        reverseButtons: true
                    }).then(async (result) => {
                        if (result.isConfirmed) {
                            window.location.href = `${config.baseUrl}mntdeposit`
                        }
                    })
                }
                else {
                    Swal.fire({
                        html: `<h4 className="mb-3">Time to bring your rig to life !</h4><div>Ready to Assemble?</div>`,
                        icon: "warning",
                        showCancelButton: true,
                        confirmButtonColor: "#435EEF",
                        cancelButtonColor: "#d33",
                        confirmButtonText: "Start Assembling",
                        reverseButtons: true
                    }).then(async (result) => {
                        if (result.isConfirmed) {
                            let res = await insertRigAction({ nft_category_id: data });;
                            if (res.success) {
                                Swal.fire({
                                    title: 'Creating Rig',
                                    html: `<img src='https://ipfs.io/ipfs/QmQLXRUGTuDofQknthYfBnxuKKhi4SW631PZ5Aaq88429S' alt=''></img>`,
                                    showConfirmButton: false,
                                    allowOutsideClick: false,
                                    className: 'creatingrigmodal',
                                    customClass: {
                                        container: 'custom-modal-container',
                                        popup: 'custom-modal-popup',
                                        title: 'custom-modal-title',
                                        image: 'custom-modal-image',
                                    },
                                    timer: 10000,
                                });
                                setTimeout(() => {
                                    Swal.fire("Your Rig is Ready to Rock");
                                }, 11000);
                                setTimeout(() => {
                                    window.location.href = `${config.baseUrl}myrig`
                                }, 13000);
                            } else {
                                Swal.fire("Failed to Assemble rig!", res.msg, "error");
                            }
                        }
                    })
                }
            };
        });

    }

    const handleShow = () => {
        setShow(true);
    }
    const handleClose = () => {
        setShow(false);
    }
    return (
        <>

            <div className={`page-wrapper${toggleSet === 1 ? '' : ' toggled'}`}>
                <Dashboardsidebarnft />
                <Toaster />
                <div className="main-container">
                    <Dashboardheadernft clickToggle={toggleManage} />
                    <div className="content-wrapper-scroll">
                        <div className="content-wrapper container mymysterybox">
                            <div className='Nftlist'>
                                <Row className='mt-4'>
                                    <Col lg={12}>
                                        <Tab.Container id="left-tabs-example" defaultActiveKey="genx">
                                            <Row>
                                                <Col sm={12} className='pl-2 pr-2'>
                                                    <Row className='align-items-center btn-rounded bg-grey' >
                                                        <Col lg={8}>
                                                            <Nav variant="pills" >

                                                                <Nav.Item>
                                                                    <Nav.Link eventKey="genx" onClick={() => getRigHistoryForUsersAPI(1)}>GEN X</Nav.Link>
                                                                </Nav.Item>
                                                                <Nav.Item>
                                                                    <Nav.Link eventKey="geny" onClick={() => getRigHistoryForUsersAPI(2)}>GEN Y</Nav.Link>
                                                                </Nav.Item>
                                                                <Nav.Item>
                                                                    <Nav.Link eventKey="genz" onClick={() => getRigHistoryForUsersAPI(3)}>GEN Z</Nav.Link>
                                                                </Nav.Item>
                                                            </Nav>
                                                        </Col>
                                                        {/* <Col lg={4} className='text-right btnassamble'>
                                                            {ShowXRig == 1 ? ShowYRig == true ?
                                                                <button className='btn btn-primary btn-rounded '
                                                                    onClick={() =>
                                                                        handleShow()
                                                                    }
                                                                    onClick={() => createRig(1)}
                                                                >Assemble X Rig</button> : <button className='btn btn-primary btn-rounded disable' disabled>Assemble X Rig</button> : ""}
                                                            {ShowXRig == 2 ? ShowYRig == true ?
                                                                <button className='btn btn-primary btn-rounded '
                                                                    onClick={() => createRig(2)}
                                                                onClick={() =>
                                                                    handleShow()
                                                                }
                                                                >Assemble Y Rig</button> : <button className='btn btn-primary btn-rounded disable' disabled>Assemble Y Rig</button> : ""}
                                                            {ShowXRig == 3 ? ShowYRig == true ?
                                                                <button className='btn btn-primary btn-rounded '
                                                                    onClick={() => createRig(3)}
                                                                onClick={() =>
                                                                    handleShow()
                                                                }
                                                                >Assemble Z Rig</button> : <button className='btn btn-primary btn-rounded disable' disabled>Assemble Z Rig</button> : ""
                                                            }
                                                        </Col> */}
                                                    </Row>
                                                </Col>
                                                <Col sm={12}>
                                                    <Tab.Content>
                                                        <Tab.Pane eventKey="genx">
                                                            <Col lg={12} className='mt-2'>

                                                                <Row>
                                                                    {rigBox.filter(item => item.categoryId === 1).map(filteredItem =>
                                                                    (<Col lg={4}>
                                                                        <div className="cardlist">
                                                                            <div className='text-center nftvideo'>
                                                                                <video
                                                                                    width="100%"
                                                                                    autoPlay
                                                                                    muted
                                                                                    playsInline
                                                                                    loop
                                                                                >
                                                                                    <source
                                                                                        src={`${config.ipfsurl +
                                                                                            filteredItem.image
                                                                                            }`}
                                                                                        type="video/mp4"
                                                                                    />
                                                                                    <source
                                                                                        src={`${config.ipfsurl +
                                                                                            filteredItem.image
                                                                                            }`}
                                                                                        type="video/ogg"
                                                                                    />
                                                                                    Your browser does not support the
                                                                                    video tag.
                                                                                </video>

                                                                            </div>

                                                                            <div className="card-body">
                                                                                <div className="row mb-3 justify-content-center">
                                                                                    <div className="col-lg-12 col-md-12 col-sm-12 col-12 text-center mb-2">
                                                                                        <div className=''>
                                                                                            <h4 className="card-title mb-1">{filteredItem.type} <span>({filteredItem.nftName})</span></h4>


                                                                                        </div>

                                                                                    </div>

                                                                                    <small className="col-lg-6 col-md-6 col-sm-6 col-6 mb-2 text-center"><div className='text-uppercase'>Required</div>
                                                                                        <div>{filteredItem.rig_quantity}</div></small>

                                                                                    <small className="col-lg-6 col-md-6 col-sm-6 col-6 text-center mb-2"><div className='text-uppercase'>Available</div>
                                                                                        <div>{filteredItem.nftCount == null ? 0 : filteredItem.nftCount}</div></small>
                                                                                    {parseInt(filteredItem.nftCount == null ? 0 : filteredItem.nftCount) < parseInt(filteredItem.rig_quantity) ? <div className="col-lg-12 col-md-12 col-sm-12 col-12 text-center">
                                                                                        <button className='btn btn-primary btn-rounded ' onClick={() => newFunc()}>Buy Now</button>

                                                                                    </div> : <div className="col-lg-12 col-md-12 col-sm-12 col-12 text-center">
                                                                                        <button className="btn btn-default btn-rounded "><i className="fa fa-check text-blue"></i></button>

                                                                                    </div>}

                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </Col>
                                                                    ))}
                                                                    <Col lg={12}>
                                                                        <div className='text-center'>
                                                                            {ShowXRig == 1 ? ShowYRig == true ?
                                                                                <button className='btn btn-primary btn-rounded mb-3'
                                                                                    
                                                                                    onClick={() => createRig(1)}
                                                                                >Proceed</button> : <button disabled className='btn btn-primary btn-rounded disable mb-3' >Proceed</button> : <button disabled className='btn btn-primary btn-rounded disable  mb-3' >Proceed</button>}
                                                                            </div>
                                                                    </Col>
                                                                </Row>
                                                            </Col>
                                                        </Tab.Pane>
                                                        <Tab.Pane eventKey="geny">
                                                            <Col lg={12} className='mt-2'>
                                                                <Row>
                                                                    {rigBox.filter(item => item.categoryId === 2).map(filteredItem =>
                                                                    (<Col lg={4}>
                                                                        <div className="cardlist">
                                                                            <div className='text-center nftvideo'>
                                                                                <video
                                                                                    width="100%"
                                                                                    autoPlay
                                                                                    muted
                                                                                    playsInline
                                                                                    loop
                                                                                >
                                                                                    <source
                                                                                        src={`${config.ipfsurl +
                                                                                            filteredItem.image
                                                                                            }`}
                                                                                        type="video/mp4"
                                                                                    />
                                                                                    <source
                                                                                        src={`${config.ipfsurl +
                                                                                            filteredItem.image
                                                                                            }`}
                                                                                        type="video/ogg"
                                                                                    />
                                                                                    Your browser does not support the
                                                                                    video tag.
                                                                                </video>
                                                                            </div>

                                                                            <div className="card-body">
                                                                                <div className="row mb-3 justify-content-center">
                                                                                    <div className="col-lg-12 col-md-12 col-sm-12 col-12 text-center mb-2">
                                                                                        <div className=''>
                                                                                            <h4 className="card-title mb-1">{filteredItem.type} <span>({filteredItem.nftName})</span></h4>
                                                                                        </div>
                                                                                    </div>

                                                                                    <small className="col-lg-6 col-md-6 col-sm-6 col-6 mb-2 text-center"><div className='text-uppercase'>Required</div>
                                                                                        <div>{filteredItem.rig_quantity}</div></small>

                                                                                    <small className="col-lg-6 col-md-6 col-sm-6 col-6 text-center mb-2"><div className='text-uppercase'>Available</div>
                                                                                        <div>{filteredItem.nftCount == null ? 0 : filteredItem.nftCount}</div></small>
                                                                                    {parseInt(filteredItem.nftCount == null ? 0 : filteredItem.nftCount) < parseInt(filteredItem.rig_quantity) ? <div className="col-lg-12 col-md-12 col-sm-12 col-12 text-center">
                                                                                        <button className='btn btn-primary btn-rounded ' onClick={newFunc}>Buy Now</button>

                                                                                    </div> : <div className="col-lg-12 col-md-12 col-sm-12 col-12 text-center">
                                                                                        <button className="btn btn-default btn-rounded "><i className="fa fa-check text-blue"></i></button>
                                                                                    </div>}

                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </Col>

                                                                    ))}
                                                                    <Col lg={12}>
                                                                        <div className='text-center'>
                                                                          {ShowXRig == 2 ? ShowYRig == true ?
                                                                                <button className='btn btn-primary btn-rounded mb-3'
                                                                                    onClick={() => createRig(2)}
                                                                                
                                                                                >Proceed</button> : <button disabled className='btn btn-primary btn-rounded disable mb-3' >Proceed</button> : <button disabled className='btn btn-primary btn-rounded disable mb-3' >Proceed</button>}
                                                                            </div>
                                                                    </Col>
                                                                </Row>


                                                            </Col>
                                                        </Tab.Pane>
                                                        <Tab.Pane eventKey="genz">
                                                            <Col lg={12} className='mt-2'>
                                                                <Row>
                                                                    {rigBox.filter(item => item.categoryId === 3).map(filteredItem =>
                                                                    (<Col lg={4}>
                                                                        <div className="cardlist">
                                                                            <div className='text-center nftvideo'>
                                                                                <video
                                                                                    width="100%"
                                                                                    autoPlay
                                                                                    muted
                                                                                    playsInline
                                                                                    loop
                                                                                >
                                                                                    <source
                                                                                        src={`${config.ipfsurl +
                                                                                            filteredItem.image
                                                                                            }`}
                                                                                        type="video/mp4"
                                                                                    />
                                                                                    <source
                                                                                        src={`${config.ipfsurl +
                                                                                            filteredItem.image
                                                                                            }`}
                                                                                        type="video/ogg"
                                                                                    />
                                                                                    Your browser does not support the
                                                                                    video tag.
                                                                                </video>
                                                                            </div>

                                                                            <div className="card-body">
                                                                                <div className="row mb-3 justify-content-center">
                                                                                    <div className="col-lg-12 col-md-12 col-sm-12 col-12 text-center mb-2">
                                                                                        <div className=''>
                                                                                            <h4 className="card-title mb-1">{filteredItem.type} <span>({filteredItem.nftName})</span></h4>
                                                                                        </div>
                                                                                    </div>

                                                                                    <div className="col-lg-6 col-md-6 col-sm-6 col-6 mb-2 text-center"><div className='text-uppercase'>Required</div>
                                                                                        <div>{filteredItem.rig_quantity}</div></div>

                                                                                    <div className="col-lg-6 col-md-6 col-sm-6 col-6 text-center mb-2"><div className='text-uppercase'>Available</div>
                                                                                        <div>{filteredItem.nftCount == null ? 0 : filteredItem.nftCount}</div></div>
                                                                                    {parseInt(filteredItem.nftCount == null ? 0 : filteredItem.nftCount) < parseInt(filteredItem.rig_quantity) ? <div className="col-lg-12 col-md-12 col-sm-12 col-12 text-center">
                                                                                        <button className='btn btn-primary btn-rounded ' onClick={newFunc}>Buy Now</button>

                                                                                    </div> : <div className="col-lg-12 col-md-12 col-sm-12 col-12 text-center">
                                                                                        <button className="btn btn-default btn-rounded "><i className="fa fa-check text-blue"></i></button>

                                                                                    </div>}

                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </Col>
                                                                    ))}
                                                                    <Col lg={12}>
                                                                        <div className='text-center'>
                                                                         {ShowXRig == 3 ? ShowYRig == true ?
                                                                                <button className='btn btn-primary btn-rounded mb-3'
                                                                                    onClick={() => createRig(3)}
                                                                               
                                                                                >Proceed</button> : <button disabled className='btn btn-primary btn-rounded disable mb-3' >Proceed</button> : ""
                                                                            }</div>
                                                                    </Col>
                                                                </Row>
                                                            </Col>
                                                        </Tab.Pane>
                                                    </Tab.Content>
                                                </Col>
                                                <Modal
                                                    show={show}
                                                    onHide={handleClose}
                                                    // backdrop="static"
                                                    className="Nftmodal"
                                                >
                                                    {/* <Modal.Header ></Modal.Header> */}
                                                    <Modal.Body closeButton className="btn-rounded">
                                                        <Row className="justify-content-center">
                                                            <Col lg={8}>
                                                                <div className="text-center mb-3">
                                                                    <div
                                                                        className="text-uppercase"
                                                                        style={{ fontSize: "1.25rem" }}
                                                                    >
                                                                        "⚙️ Hold Tight: We're Revamping Rig Creation to Serve You Better!"
                                                                    </div>

                                                                </div>
                                                            </Col>
                                                        </Row>
                                                    </Modal.Body>
                                                </Modal>
                                            </Row>
                                        </Tab.Container>
                                    </Col>
                                </Row>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )

}
export default Rig;